import Dialog from './src/index.vue.mjs';
import './src/type.mjs';

const PlusDialog = Dialog;

export { PlusDialog };
